<template>
	<multiselect class="custom-multiselect" v-bind="allBindings" v-on="$listeners" placeholder="" @input="changeLang">
		<template slot="singleLabel" slot-scope="{ option }">
			<img class="option__image" :src="option.img" alt="Sth" />
			<span class="option__desc">
			<span class="option__title">{{ option.title }}</span>
			</span>
		</template>

		<template slot="option" slot-scope="{ option }">
			<img class="option__image" :src="option.img" alt="Sth" />
			<span class="option__desc">
				<span class="option__title">{{ option.title }}</span>
				<!-- <span class="option__small">{{ option.desc }}</span> -->
			</span>
		</template>
	</multiselect>
</template>

<script>
import MultiselectMixin from "vue-multiselect/src/multiselectMixin";

export default {
	props: MultiselectMixin.props,
	computed: {
		allBindings() {
			// Need to proxify both props and attrs, for example for showLabels
			return { ...this.$props, ...this.$attrs };
		}
	},
	methods: {
		changeLang(option) {
			this.$i18n.locale = option.title
			localStorage.setItem('i18n-locale', option.title)
      		this.$router.replace({ params: { lang: option.title } })
		}
	}
}
</script>

<style lang="scss" scoped>
.option__image { 
	width: 35px;
	margin-left: 9px;
}
.option__desc, .option__title { 
    display: none;
}

.multiselect {
    width: 80px;
    color:var(--bg);
	margin: auto;
}

.multiselect__content-wrapper {
    overflow-x: hidden;
}


.multiselect--active {
    width: 80px;
}

.multiselect .multiselect__select { 
    display: none !important;
}

.multiselect__tags {
	padding: 8px 10px 0 8px;
}

// @media screen and (max-width: 500px) {
// 	.multiselect {
//     width: 65%;
// }

// .multiselect--active {
//     width: 65%;
// }
// }
</style>